module.exports = __webpack_public_path__ + "img/sqlite-client.b097f197.svg";